import type React from "react";
import {useCallback} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useParams} from "react-router-dom";

import {usePersonalBestV2} from "~/api/hooks/usePersonalBestV2";
import CustomButton from "~/component/common/CustomButton";
import {useUserInput} from "~/contexts/user-input/UserInputCoordinatorProvider";
import {auth} from "~/firebase/firebase";

interface MainActionButtonProps {
  closeModal: () => void;
}

const MainActionButton: React.FC<MainActionButtonProps> = ({closeModal}) => {
  const {id: levelId} = useParams<{id: string}>();
  const [myUser] = useAuthState(auth);
  const {resetSimulation} = useUserInput();

  // Get the personal best data
  const {data: personalBestV2} = usePersonalBestV2({
    levelId,
    id: myUser?.uid,
  });

  // Check if user has personal best
  const hasPersonalBest = !!personalBestV2?.replay;

  const handleMainAction = useCallback(() => {
    resetSimulation();
    closeModal();
  }, [closeModal, resetSimulation]);

  return (
    <CustomButton
      onClick={handleMainAction}
      className="w-full py-2 bg-white text-gray-900 rounded-lg transition-colors hover:bg-gray-200"
    >
      {hasPersonalBest ? "Improve" : "Play"}
    </CustomButton>
  );
};

export default MainActionButton;
